<template>
  <v-dialog v-model="dialog" max-width="480px">
    <v-card>
      <v-card-title class="mx-3">
        {{ title ? title : $t("Import.batchImport", [objName]) }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-4 py-8 text-center subtitle-1">
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="text-left my-2">
              {{ $t("Template.chooseMaterial") }}
            </v-list-item-title>
            <v-list-item-subtitle>
              <v-btn
                color="primary"
                dark
                class="ms-1"
                @click="materialDialog = true"
              >
                {{ $t("Template.chooseMaterial") }}
              </v-btn>
            </v-list-item-subtitle>
            <v-list-item-title class="text-left my-2" v-if="!hideDownload">
              {{ $t("Import.downloadFieldTemplate", [objName]) }}
            </v-list-item-title>
            <v-list-item-subtitle v-if="!hideDownload">
              <v-btn
                color="primary"
                dark
                class="ms-1"
                @click="downloadImportTemplate()"
                v-if="batchImport"
              >
                {{ $t("Import.downloadFieldTemplateBtn") }}
              </v-btn>
              <v-btn
                color="primary"
                dark
                class="ms-1"
                @click="downloadBatchPriceTemplate()"
                v-if="batchPrice"
              >
                {{ $t("Import.downloadFieldTemplateBtn") }}
              </v-btn>
            </v-list-item-subtitle>
            <v-list-item-title class="text-left my-2">
              {{ $t("Import.uploadField", [objName]) }}
            </v-list-item-title>
            <v-list-item-subtitle>
              <v-file-input
                v-model="excelFile"
                show-size
                :label="$t('Import.fileInputLabel')"
                accept=".xls,.xlsx"
              ></v-file-input>
            </v-list-item-subtitle>
            <span v-if="isTips">
              <v-list-item-title class="text-left my-2">
                {{ $t("$vuetify.alert") }}
              </v-list-item-title>
              <v-list-item-subtitle
                class="text-left my-1"
                v-for="detail in tipDetails"
                :key="detail"
              >
                {{ detail }}
              </v-list-item-subtitle>
            </span>
            <span v-if="isHint" class="text-left my-1 red--text">
              {{ hintDetail }}
            </span>
          </v-list-item-content>
        </v-list-item>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn
          color="primary"
          depressed
          @click="
            $emit('import', { excel: excelFile })
          "
        >
          {{ $t("Import.confirmImport") }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <MaterialsSelectsDialog
      v-model="materialDialog"
      :materialIds="materialIds"
      @confirm="choosedMaterials = $event"
    />
  </v-dialog>
</template>
<script>
import MaterialsSelectsDialog from "@/components/plugins/MaterialsSelectsDialog";
import MaterialTemplates from "@/api/material_templates";
import i18n from "@/i18n";

export default {
  name: "BatchImportExcelAlert",

  props: {
    value: Boolean,
    title: String,
    objName: String,
    isTips: Boolean,
    isHint: Boolean,
    tipDetails: Array,
    hintDetail: String,
    hideDownload: Boolean,
    batchImport: Boolean,
    batchPrice: Boolean,
  },
  components: {
    MaterialsSelectsDialog,
  },

  data: () => ({
    dialog: false,
    excelFile: null,
    materialDialog: false,
    materialIds: [],
    choosedMaterials: [],
  }),
  methods: {
    downloadImportTemplate() {
      MaterialTemplates.importBatchTemplateExport({
        material_ids: this.materialIds,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$snackbar.info(
              i18n.t("Import.downloadFieldTemplateSuccess", [
                i18n.t("Template.ObjectName"),
              ])
            );
            this.materialIds = [];
          }
        }.bind(this)
      );
    },
    downloadBatchPriceTemplate() {
      MaterialTemplates.batchPriceExport({
        material_ids: this.materialIds,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$snackbar.info(
              i18n.t("Import.downloadFieldTemplateSuccess", [
                i18n.t("Template.ObjectName"),
              ])
            );
            this.materialIds = [];
          }
        }.bind(this)
      );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          this.excelFile = null;
          this.materialIds = [];
          this.sub_account_type = null;
        }
        this.$emit("input", this.dialog);
      },
    },
    choosedMaterials: {
      handler() {
        this.choosedMaterials.forEach((material) => {
          this.materialIds.push(material.id);
        });
      },
    },
  },
};
</script>